import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawTrashIcon from "./RawTrashIcon.svg.jsx";

const TrashIcon = forwardRef((props, ref) => {
  return <Icon ref={ref} SvgComponent={RawTrashIcon} {...props} />;
});

TrashIcon.displayName = "TrashIcon";
export default TrashIcon;
